import gql from "graphql-tag";

export const CreateProfileConsents = gql`
 mutation CreateProfileConsents(
    $ProfileId: String!
    $Type: ProfileConsentType!
) {
  CreateProfileConsents(Input: {
    ProfileId: $ProfileId,
    Type: $Type
  })
    {
      CreatedAt
      Id
      Ip
      ProfileId
      Type
      UpdatedAt
    }
  }`;